import { RestoreOutlined } from "@mui/icons-material";
import ApiConfig from "../../Utils/Configs/apiConfig";

const mockPublicDocumentUrls: Record<string, string> = {
  "1": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2FMedia%20(1).jpeg",
  "2": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36959.jpg",
  "3": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36958.jpg",
  "4": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36953.jpg",
  "5": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36948.jpg",
  "6": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36954.jpg",
  "7": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36947.jpg",
  "8": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36939.pdf",
  "9": "https://iykons-qa-iyvault-e7b3d1a2.s3.eu-west-2.amazonaws.com/4348aa72-a665-4fcf-894a-e860af1a79de%2F36941.jpg",
};

export const GetPublicDocumentUrlService = async (code: string) => {
  try {
    // if (mockPublicDocumentUrls[code]) {
    //   return mockPublicDocumentUrls[code];
    // }

    const response = await ApiConfig.getInstance().get(
      // `/PublicDocument/${code}`
      `/PublicDocument/${code}`
    );
    console.log(response);
    return response.data.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
